import {FILTER_USER_STATE, Role} from '../../../incase-domain/user';
import {UserFilterOptions} from '../../../incase-domain/userFilterOptions';
import {UseListParamsReturn} from '../../../hooks/listParams';
import {useListSearchParams} from '../../../hooks/useListSearchParams';

export function useUsersListSearchParams(): UseListParamsReturn {
    return useListSearchParams(
        {},
        {
            sort: {allowedFields: ['username']},
            filterFields: {
                archived: {allowedValues: ['true', 'false']},
                roles: {
                    allowedValues: Object.values(Role).filter((role) => role !== Role.USER),
                    multiple: true,
                },
            },
        }
    );
}

export function filtersToUserFilterOptions(filters: Record<string, string>): UserFilterOptions {
    const filterQuery: UserFilterOptions = {};

    if (filters.archived === 'true') {
        filterQuery.archived = FILTER_USER_STATE.ARCHIVED;
    } else if (filters.archived === 'false') {
        filterQuery.archived = FILTER_USER_STATE.ACTIVE;
    }

    if (filters.roles) {
        filterQuery.roles = filters.roles.split(',').filter(Boolean) as Role[];
    }

    return filterQuery;
}
